import moment from "moment";
import React from "react";
import {
    UncontrolledPopover,
    PopoverHeader,
    PopoverBody
} from "reactstrap";
import UserName from "../Reusable/UserName";
import PatientProfileHeaderPrint from "../Reusable/PatintProfileHeaderPrint";
import { useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import LottieLoader from '../../components/LottieLoader';
import lottieEmptyFile from '../../files/animation/empty_new.json';
import { getMonthlyPhoneConsultationPerformerName, getPatientMonthlyPhoneConsultationBy } from "./pmSessionConsultation.helpers";
const _ = require("lodash");

const CCMProfilePrint = React.forwardRef((props, ref) => {
    const { profile, userDetails } = useSelector(state => state.user);
    const {
        ongoingUserViolationRequestPrint,
        usersViolationsPrintData,
        latestReadingUser,
        ccmTotalDuration,
        rpmTotalDuration
    } = useSelector(state => state.careprovider);

    React.useEffect(() => {
        document.title = "Patient Management Session Report";
    }, []);

    const tableStyle = {
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: "25px",
        border: "1px solid #ccc",
        fontSize: "14px",
        pageBreakInside: "avoid"
    };

    const thStyle = {
        border: "1px solid #ddd",
        padding: "10px",
        textAlign: "left",
        width: "30%",
        backgroundColor: "#f9f9f9",
        fontWeight: "bold"
    };

    const tdStyle = {
        border: "1px solid #ddd",
        padding: "10px",
        textAlign: "left",
        backgroundColor: "#fff"
    };

    function billable(row) {
        let cptcode99457;
        let cptcode99458;
        let cptCode99490;
        let cptCode99439;
        let cptCode99453;
        let cptCode99454;
        let cptCode99445;
        let cptCode99470;
        const codeModel = row && row.codeModel ? row.codeModel : undefined;

        //*******************************************
        // RPM: CPT CODE - 99457 Information.
        //*******************************************
        //* 99457 - This RPM CPT code is populated every month, 
        //* IF the patient has had at least 20 minutes of review, a phone consultation with the patient AND at least 2 vital's reading needed
        //---------------------------------- START CPT CODE 99457 ----------------------------------//
        if (codeModel && _.size(codeModel.cpt99457) > 0) {
            cptcode99457 = [];
            _.map(codeModel.cpt99457, (value, index) => {
                cptcode99457.push(
                    <div key={`key99457${row._id}`}>
                        <button className="btn btn-sm btn-info session-code-button-radial" id={`popover99457${row._id}-${index}`}> 99457 </button>
                        <UncontrolledPopover trigger="legacy" placement="top" target={`popover99457${row._id}-${index}`}>
                            <PopoverHeader>Description</PopoverHeader>
                            <PopoverBody> There has been an attestation of a phone consultation and at least 20 minutes of Remote Patient Monitoring performed on this patient this month. </PopoverBody>
                        </UncontrolledPopover>
                    </div>
                );
            });
        }
        //---------------------------------- END CPT CODE 99457 ----------------------------------//

        //*******************************************
        // RPM: CPT CODE - 99458 Information.
        //*******************************************
        //* 99458 - This RPM CPT code is populated IF the patient qualified for 99457 AND had an additional 20 minutes of review, 
        //* in excess of the required 20 minutes for CPT 99457. For example if the patient’s total review time was more than 40 minutes, 
        //* we would populate one 99458 for the additional 20 minutes over the required 20 minutes. 
        //* If the total review time was over 60 minutes we would populate (2) 99458 CPT Codes because there were two separate additional 
        //* 20 minutes reviewed in excess to the initial 20 minutes required for CPT 99454. This CPT code can only be populated 3 times each month, 
        //* so if there is more than 80 minutes of review we only populate (3) 99458, no matter how much time. They limit billing for 99458 to only (3) per month.
        //---------------------------------- START CPT CODE 99458 ----------------------------------//  
        if (codeModel && _.size(codeModel.cpt99458) > 0) {
            cptcode99458 = [];
            _.map(codeModel.cpt99458, (value, index) => {
                cptcode99458.push(
                    <div key={`key99458${row._id}`}>
                        <button className="btn btn-sm btn-warning session-code-button-radial" id={`popover99458${row._id}-${index}`}>99458</button>
                        <UncontrolledPopover trigger="legacy" placement="top" target={`popover99458${row._id}-${index}`}>
                            <PopoverHeader>Description</PopoverHeader>
                            <PopoverBody>
                                The patient has met the condition of a minimum requirement of 40
                                grand total minutes of RPM a month.
                            </PopoverBody>
                        </UncontrolledPopover>
                    </div>
                );
            });
        }
        //---------------------------------- END CPT CODE 99458 ----------------------------------//
        //---------------------------------- END RPM LOGIC ---------------------------------------//

        //---------------------------------- START CCM LOGIC -------------------------------------//
        // Calculate the CCM TIME 
        //-----------------------------------------------------------------------------------------//  
        //*******************************************
        // CCM: CPT CODE - 99490 Information
        //*******************************************
        //* 99490 - This CCM CPT code is populated every month,
        //* IF the patient has had at least 20 minutes of review AND a phone consultation with the patient.
        //---------------------------------- START CPT CODE 99490 ----------------------------------//

        if (codeModel && _.size(codeModel.cpt99490) > 0) {
            cptCode99490 = [];
            _.map(codeModel.cpt99490, (value, index) => {
                cptCode99490.push(
                    <div key={`key99458${row._id}`}>
                        <button className="btn btn-sm btn-info session-code-button-radial" id={`popover99490${row._id}-${index}`}> 99490 </button>
                        <UncontrolledPopover trigger="legacy" placement="top" target={`popover99490${row._id}-${index}`}>
                            <PopoverHeader>Description</PopoverHeader>
                            <PopoverBody>
                                There has been an attestation of a phone consultation and at least
                                20 minutes of Chronic Care Management performed on this patient this
                                month.
                            </PopoverBody>
                        </UncontrolledPopover>
                    </div>
                );
            });
        }
        //---------------------------------- END CPT CODE 99490 ----------------------------------//

        //*******************************************
        // CCM: CPT CODE - 99439 Information
        //*******************************************
        //* 99439 - This CCM CPT code is populated IF the patient qualified for 99490 AND had an additional 20 minutes of review, 
        //* in excess of the required 20 minutes for CPT 99490. For example if the patient’s total review time was more than 40 minutes, 
        //* we would populate one 99439 for the additional 20 minutes over the required 20 minutes. 
        //* If the total review time was over 60 minutes we would populate (2) 99439 CPT Codes because there were two separate additional 20 minutes 
        //* reviewed in excess to the initial 20 minutes required for CPT 99454. This CPT code can only be billed 2 times each month, 
        //* so if there is more than 60 minutes of review we only populate (2) 99439, no matter how much time. They limit 99439 to only (2) per month.
        //---------------------------------- START CPT CODE 99439 ----------------------------------//
        if (codeModel && _.size(codeModel.cpt99439) > 0) {
            cptCode99439 = [];
            _.map(codeModel.cpt99439, (value, index) => {
                cptCode99439.push(
                    <div>
                        <button className="btn btn-sm btn-warning session-code-button-radial" id={`popover99439${row._id}-${index}`}>99439</button>
                        <UncontrolledPopover trigger="legacy" placement="top" target={`popover99439${row._id}-${index}`}>
                            <PopoverHeader>Description</PopoverHeader>
                            <PopoverBody>
                                There has been an attestation of an additional 20 minutes of
                                Chronic Care Management performed on this patient this month.
                            </PopoverBody>
                        </UncontrolledPopover>
                    </div>
                );
            });
        }
        //---------------------------------- END CPT CODE 99439 ----------------------------------//

        //---------------------------------- CPT CODE 99453 ---------------------------------------//
        // Initial setup && Completed Call
        // This RPM CPT code is only populated once. The first time we bill for 99454, 
        // we bill for 99453. This code is for the initial training and
        //-----------------------------------------------------------------------------------------//
        if (codeModel && _.size(codeModel.cpt99453) > 0) {
            cptCode99453 = [];
            _.map(codeModel.cpt99453, (value, index) => {
                cptCode99453.push(
                    <div>
                        <button className="btn btn-sm btn-primary text-white session-code-button-radial" id={`popover99453${row._id}-${index}`}> 99453 </button>
                        <UncontrolledPopover trigger="legacy" placement="top" target={`popover99453${row._id}-${index}`}>
                            <PopoverHeader>Description</PopoverHeader>
                            <PopoverBody>
                                Patient have met the condition Initial Setup & Training Completed!
                            </PopoverBody>
                        </UncontrolledPopover>
                    </div>
                );
            });
        }
        //---------------------------------- CPT CODE 99454 ---------------------------------------//
        // This RPM CPT code is populated every month, 
        // IF the patient has had at least 16 unique days with any type of a vital upload, within that month.
        //-----------------------------------------------------------------------------------------//
        if (codeModel && _.size(codeModel.cpt99454) > 0) {
            cptCode99454 = [];
            _.map(codeModel.cpt99454, (value, index) => {
                cptCode99454.push(
                    <div>
                        <button className="btn btn-sm btn-success text-white session-code-button-radial" id={`popover99454${row._id}-${index}`} type="button">99454</button>
                        <UncontrolledPopover trigger="legacy" placement="right" target={`popover99454${row._id}-${index}`}>
                            <PopoverHeader>Description</PopoverHeader>
                            <PopoverBody>
                                Patient have met the condition at least 16 days on the system and
                                should have records of activity every month!
                            </PopoverBody>
                        </UncontrolledPopover>
                    </div>
                );
            });
        }
        //---------------------------------- CPT CODE 99445 ---------------------------------------//
        if (codeModel && _.size(codeModel.cpt99445) > 0) {
        cptCode99445 = [];
        _.map(codeModel.cpt99445, (value, index) => {
            cptCode99445.push(
            <div>
                <button className="btn btn-sm btn-success text-white session-code-button-radial cptCodeButton99445" id={`popover99445${row._id}-${index}`} type="button">99445</button>
                <UncontrolledPopover trigger="legacy" placement="right" target={`popover99445${row._id}-${index}`}>
                <PopoverHeader>Description</PopoverHeader>
                <PopoverBody>
                    Device supply and RPM data monitoring for 2–15 adherence days in a month.
                    Populates when adherence days are between 2 and 15.
                </PopoverBody>
                </UncontrolledPopover>
            </div>
            );
        });
        }
    
        //---------------------------------- CPT CODE 99470 ---------------------------------------//
        if (codeModel && _.size(codeModel.cpt99470) > 0) {
        cptCode99470 = [];
        _.map(codeModel.cpt99470, (value, index) => {
            cptCode99470.push(
            <div>
                <button className="btn btn-sm btn-success text-white session-code-button-radial cptCodeButton99470" id={`popover99470${row._id}-${index}`} type="button">99470</button>
                <UncontrolledPopover trigger="legacy" placement="right" target={`popover99470${row._id}-${index}`}>
                <PopoverHeader>Description</PopoverHeader>
                <PopoverBody>
                    There has been an attestation of Remote Patient Monitoring services performed
                    on this patient for 10–20 minutes during the current month.
                </PopoverBody>
                </UncontrolledPopover>
            </div>
            );
        });
        }
        if (cptCode99490 || cptCode99439 || cptCode99453 || cptCode99454 || cptcode99457 || cptcode99458 || cptCode99445 || cptCode99470) {
            return (
                <div className="mx-auto">
                    {cptCode99445} {cptCode99453}
                    {cptCode99454} {cptCode99470}
                    {cptcode99457} {cptcode99458}
                    {cptCode99490} {cptCode99439}
                </div>
            );
        } else {
            return (
                <div className="mx-auto">
                    -
                </div>
            );
        }
    }

    function formatDate(cell) {
        return moment(cell).tz("America/New_York").format("MMMM DD, YYYY hh:mm:ss A") + " (America/New York)";
    }
    function fullnameChild(cell) {
        return <UserName user={cell} />;
    }
    const defaultSorted = [
        {
            dataField: "endTime",
            order: "desc"
        }
    ];

    const NoDataIndicationPM = () => (
        <div>
            <LottieLoader
                loadLoop={false}
                autoplayLoop={true}
                source={lottieEmptyFile}
                Lheight={200}
                Lwidth={200}
                titleSmall={"Sorry! No pm session record found :("}
                subTitleSmall={"We can't find any pm session record."}
            />
        </div>
    );
    return (
        <div ref={ref} id="printCCM" className="text-center mt-5">
            <div className="print-page-title">Required Documentation for CPT Code 99454 / 99457</div>

            <PatientProfileHeaderPrint
                profile={profile}
                latestReadingUser={latestReadingUser}
                ccmTotalDuration={ccmTotalDuration}
                rpmTotalDuration={rpmTotalDuration}
                userDetails={userDetails}
            />
            {(props.startDate || props.endDate) && (
                <div
                    className="d-flex mb-2 mt-3"
                    style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        maxWidth: "400px",
                    }}
                >
                    <span style={{ marginRight: "8px", color: "#333" }}>Filtered Date Range:</span>
                    <span style={{ fontWeight: "bold", color: "#000" }}>
                        {props.startDate ? new Date(props.startDate).toLocaleDateString() : "—"}{" "}
                        <span style={{ color: "#888" }}>to</span>{" "}
                        {props.endDate ? new Date(props.endDate).toLocaleDateString() : "—"}
                    </span>
                </div>
            )}
            {props.pmRecords?.length > 0 ? (
                props.pmRecords.map((row) => (
                    <table key={row._id} style={tableStyle}>
                        <tbody>
                            <tr>
                                <th style={thStyle}>DOB</th>
                                <td style={tdStyle}>{moment(row.bday).format("MMMM DD, YYYY")}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Last Upload Date</th>
                                <td style={tdStyle}>
                                    {row.lastReading?.deviceReadingDate
                                        ? moment(row.lastReading.deviceReadingDate).format("MMMM DD, YYYY")
                                        : row.deviceReadingDate
                                            ? moment(row.deviceReadingDate).format("MMMM DD, YYYY")
                                            : "NONE"}
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Condition(s) Managed</th>
                                <td style={tdStyle}>{row.conditions?.join(", ") || "-"}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Organization</th>
                                <td style={tdStyle}>{row.organization || "-"}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Enrolled Program(s)</th>
                                <td style={tdStyle}>{row.enrolledPrograms || "-"}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Total CCM Time</th>
                                <td style={tdStyle}>{row.totalTimeCCM || "00:00:00"}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Total RPM Time</th>
                                <td style={tdStyle}>{row.totalTimeRPM || "00:00:00"}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Billable CPT Code(s)</th>
                                <td style={tdStyle}>
                                    {billable(row)}
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Adherence Days</th>
                                <td style={tdStyle}>
                                    {row.adhenrenceDay}
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Primary Insurance</th>
                                <td style={tdStyle}>{row.insuranceProvider || "-"}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Called</th>
                                <td style={tdStyle}>{row.isCalled ? "Yes" : "No"}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Monthly Phone Consultation By</th>
                                <td style={tdStyle}>{getPatientMonthlyPhoneConsultationBy(row) || "-"}</td>
                            </tr>
                        </tbody>
                    </table>
                ))
            ) : (
                <p style={{ fontSize: "16px", color: "#888" }}>No records found.</p>
            )}
            {props?.pmRecords[0] && props?.pmRecords[0]?.ccmTrackings !== undefined && (
            <div
                className="child-pm-session-table"
                style={{
                padding: 0,
                margin: 0,
                width: "100%",
                overflowX: "auto",
                }}
            >
                <BootstrapTable
                wrapperClasses="table-responsive"
                keyField="_id"
                noDataIndication={() => <NoDataIndicationPM />}
                data={_.orderBy(props.pmRecords[0].ccmLogs, "startTime", "asc")}
                defaultSorted={defaultSorted}
                columns={[
                    {
                    dataField: "careProvider.lname",
                    text: "Tracked By",
                    formatter: (cell, row) => fullnameChild(row.careProvider),
                    headerStyle: () => ({
                        width: "150px",
                        textAlign: "left",
                        fontSize: "11px",
                        wordBreak: "break-word",
                    }),
                    style: { fontSize: "11px", wordBreak: "break-word" },
                    },
                    {
                    dataField: "pmMode",
                    text: "Patient Monitor Mode",
                    headerStyle: () => ({
                        width: "130px",
                        fontSize: "11px",
                    }),
                    style: { fontSize: "11px" },
                    },
                    {
                    dataField: "startTime",
                    text: "Start Time",
                    formatter: formatDate,
                    headerStyle: () => ({
                        width: "130px",
                        fontSize: "11px",
                    }),
                    style: { fontSize: "11px" },
                    },
                    {
                    dataField: "endTime",
                    text: "End Time",
                    formatter: formatDate,
                    headerStyle: () => ({
                        width: "130px",
                        fontSize: "11px",
                    }),
                    style: { fontSize: "11px" },
                    },
                    {
                    dataField: "time",
                    text: "Total Collected Time",
                    formatter: (cell, row) => row.time,
                    headerStyle: () => ({
                        width: "120px",
                        fontSize: "11px",
                    }),
                    style: { fontSize: "11px" },
                    },
                    {
                    dataField: "comment",
                    text: "Note",
                    headerStyle: () => ({
                        width: "300px",
                        textAlign: "left",
                        fontSize: "11px",
                        wordBreak: "break-word",
                    }),
                    formatter: (cell) => (
                        <p style={{ margin: 0, fontSize: "11px", wordBreak: "break-word" }}>
                        {cell}
                        </p>
                    ),
                    style: { fontSize: "11px", wordBreak: "break-word" },
                    },
                    {
                    dataField: "hadPhoneConsultation",
                    text: "Call Included",
                    formatter: (cell, row) => (row.hadPhoneConsultation ? "Yes" : "No"),
                    headerStyle: () => ({
                        width: "100px",
                        fontSize: "11px",
                    }),
                    style: { fontSize: "11px" },
                    },
                    {
                    dataField: "monthlyPhoneConsultationBy",
                    text: "Monthly Phone Consultation By",
                    formatter: (cell, row) => getMonthlyPhoneConsultationPerformerName(row),
                    headerStyle: () => ({
                        width: "160px",
                        fontSize: "11px",
                    }),
                    style: { fontSize: "11px" },
                    },
                ]}
                />
            </div>
            )}
        </div>
    );
});

export default CCMProfilePrint;